import React from "react";
import PropTypes from "prop-types";
import "./ReceiptDetailHeading.scss";

const ReceiptDetailHeading = ({ children }) => {
    return (
        <div className="receipt-detail-heading">
            <div className="receipt-detail-heading__content">
                <span className="-type--small -text-transform--uppercase">
                    {children}
                </span>
            </div>
        </div>
    );
};

ReceiptDetailHeading.propTypes = {
    children: PropTypes.any,
};

export default ReceiptDetailHeading;
